import { render, staticRenderFns } from "./TaxWarrants.vue?vue&type=template&id=3f8113d0&scoped=true&"
import script from "./TaxWarrants.vue?vue&type=script&lang=js&"
export * from "./TaxWarrants.vue?vue&type=script&lang=js&"
import style0 from "./TaxWarrants.vue?vue&type=style&index=0&id=3f8113d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8113d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
